var React = require('react');

function FTTwitter (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",{"transform":"translate(-281.000000, -3054.000000)"},React.createElement("path",{"fill":"#1A1818","d":"M310,3060c-1.1,0.5-2.2,0.8-3.4,0.9c1.2-0.7,2.2-1.9,2.6-3.3c-1.1,0.7-2.4,1.2-3.8,1.4\r\n\t\t\tc-1.1-1.2-2.6-1.9-4.3-1.9c-3.8,0-6.7,3.6-5.8,7.3c-4.9-0.2-9.3-2.6-12.3-6.2c-1.6,2.7-0.8,6.2,1.8,7.9c-1,0-1.9-0.3-2.7-0.7\r\n\t\t\tc-0.1,2.8,1.9,5.3,4.8,5.9c-0.8,0.2-1.8,0.3-2.7,0.1c0.8,2.4,3,4.1,5.6,4.1c-2.5,2-5.7,2.8-8.8,2.5c2.6,1.7,5.8,2.7,9.1,2.7\r\n\t\t\tc11,0,17.3-9.3,16.9-17.7C308.2,3062.2,309.2,3061.2,310,3060"}))));
}

FTTwitter.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 29 30","enableBackground":"new 0 0 29 30","xmlSpace":"preserve"};

module.exports = FTTwitter;

FTTwitter.default = FTTwitter;
